export default {"src":"/_next/static/image/public/icons/facebook.32eae05210b5e51f979b418be1df1590.svg","height":19,"width":11};